import { Direction, wrapIndex } from "./point";
export const makeRow = (r, d, i) => ({
    direction: d,
    start: wrapIndex([i, r.start]).toPoint(d),
    end: wrapIndex([i, r.end]).toPoint(d),
    eye1: r.eye1 !== undefined ? wrapIndex([i, r.eye1]).toPoint(d) : undefined,
    eye2: r.eye2 !== undefined ? wrapIndex([i, r.eye2]).toPoint(d) : undefined,
});
export const wrapRow = (self) => ({
    unwrap: () => self,
    overlap: overlap(self),
    adjacent: adjacent(self),
    eyes: eyes(self),
});
const overlap = (self) => (p) => {
    const [px, py] = p;
    const [sx, sy] = self.start;
    const [ex, ey] = self.end;
    switch (self.direction) {
        case Direction.vertical:
            return px == sx && bw(sy, py, ey);
        case Direction.horizontal:
            return py == sy && bw(sx, px, ex);
        case Direction.ascending:
            return bw(sx, px, ex) && bw(sy, py, ey) && px - sx == py - sy;
        case Direction.descending:
            return bw(sx, px, ex) && bw(ey, py, sy) && px - sx == sy - py;
        default:
            return false;
    }
};
const adjacent = (self) => (other) => {
    if (self.direction !== other.direction)
        return false;
    const [sx, sy] = self.start;
    const [ox, oy] = other.start;
    const [xd, yd] = [sx - ox, sy - oy];
    switch (self.direction) {
        case Direction.vertical:
            return Math.abs(xd) === 0 && Math.abs(yd) === 1;
        case Direction.horizontal:
            return Math.abs(xd) === 1 && Math.abs(yd) === 0;
        case Direction.ascending:
            return Math.abs(xd) === 1 && xd === yd;
        case Direction.descending:
            return Math.abs(xd) === 1 && xd === -yd;
        default:
            return false;
    }
};
const eyes = (self) => () => {
    if (self.eye1 === undefined) {
        return [];
    }
    else if (self.eye2 === undefined) {
        return [self.eye1];
    }
    else {
        return [self.eye1, self.eye2];
    }
};
const bw = (a, x, b) => a <= x && x <= b;
//# sourceMappingURL=row.js.map